module.exports = __webpack_public_path__ + "static/media/notification_announcement_icon.5acc4313.svg";